document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     CART STATE — single source of truth, updated locally first
  ============================================================ */
  var cartState = null; // cached cart object from Shopify

  function formatMoney(cents) {
    return '₹' + Math.round(cents / 100);
  }

  /* ── update the nav badge instantly from local state ── */
  function updateCartCount(count) {
    var el = document.querySelector('.nav-cart-count');
    if (count > 0) {
      if (!el) {
        el = document.createElement('span');
        el.className = 'nav-cart-count';
        var nc = document.querySelector('.nav-cart');
        if (nc) nc.appendChild(el);
      }
      el.textContent = count;
    } else {
      if (el) el.remove();
    }
  }

  /* ── render cart drawer from a cart object (no fetch needed) ── */
  function renderCart(cart) {
    cartState = cart;
    updateCartCount(cart.item_count);

    var body = document.getElementById('cartBody');
    var foot = document.getElementById('cartFoot');
    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-drawer-empty"><span style="font-size:40px">🛒</span><span>Your cart is empty</span></div>';
      if (foot) foot.style.display = 'none';
      return;
    }

    var frag = document.createDocumentFragment();
    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'cart-item-row';
      row.dataset.key = item.key;
      row.innerHTML =
        (item.image
          ? '<img class="cart-item-img" src="' + item.image + '" alt="' + item.title + '" loading="lazy">'
          : '<div class="cart-item-img" style="display:flex;align-items:center;justify-content:center;font-size:28px">📦</div>'
        ) +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + item.product_title + '</div>' +
          '<div class="cart-item-price">' + formatMoney(item.price) + '</div>' +
          '<div class="cart-item-qty">' +
            '<button class="cart-qty-btn cart-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
            '<span class="cart-qty-num">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn cart-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '<span class="cart-remove" data-key="' + item.key + '">Remove</span>' +
          '</div>' +
        '</div>';
      frag.appendChild(row);
    });

    body.innerHTML = '';
    body.appendChild(frag);

    var totalEl = document.getElementById('cartTotal');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (foot) foot.style.display = 'block';
  }

  /* ── fetch cart from server and render ── */
  function fetchAndRenderCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {
        var body = document.getElementById('cartBody');
        if (body) body.innerHTML = '<div class="cart-drawer-empty"><span>Could not load cart</span></div>';
      });
  }

  /* ============================================================
     CART DRAWER — pre-built at page load, instant open
  ============================================================ */
  (function buildCartDrawer() {
    var overlay = document.createElement('div');
    overlay.className = 'cart-overlay';
    overlay.id = 'cartOverlay';

    var drawer = document.createElement('div');
    drawer.className = 'cart-drawer';
    drawer.id = 'cartDrawer';
    drawer.innerHTML =
      '<div class="cart-drawer-head">' +
        '<span class="cart-drawer-title">Your Cart</span>' +
        '<button class="cart-drawer-close" id="cartClose" aria-label="Close cart">✕</button>' +
      '</div>' +
      '<div class="cart-drawer-body" id="cartBody">' +
        '<div class="cart-drawer-empty"><span style="font-size:40px">🛒</span><span>Your cart is empty</span></div>' +
      '</div>' +
      '<div class="cart-drawer-foot" id="cartFoot" style="display:none">' +
        '<div class="cart-subtotal"><span>Subtotal</span><span id="cartTotal"></span></div>' +
        '<a href="/checkout" class="cart-checkout-btn">Checkout →</a>' +
        '<span class="cart-continue" id="cartContinue">← Continue Shopping</span>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    document.getElementById('cartClose').addEventListener('click', closeCart);
    overlay.addEventListener('click', closeCart);
    document.getElementById('cartContinue').addEventListener('click', closeCart);

    /* event delegation for qty/remove — one listener, covers all items */
    document.getElementById('cartBody').addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-qty-btn');
      var rem = e.target.closest('.cart-remove');
      if (btn) changeItemQty(btn.dataset.key, parseInt(btn.dataset.qty) || 0);
      if (rem) changeItemQty(rem.dataset.key, 0);
    });
  })();

  function openCart() {
    document.getElementById('cartOverlay').classList.add('open');
    document.getElementById('cartDrawer').classList.add('open');
    document.body.style.overflow = 'hidden';
    /* only fetch if we have no cached state */
    if (!cartState) {
      fetchAndRenderCart();
    } else {
      renderCart(cartState); /* instant — no fetch */
    }
  }

  function closeCart() {
    document.getElementById('cartOverlay').classList.remove('open');
    document.getElementById('cartDrawer').classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ── optimistic qty/remove: update UI instantly, sync server in background ── */
  function changeItemQty(key, qty) {
    if (!cartState) return;

    /* optimistic local update */
    var newItems = [];
    var removedPrice = 0;
    cartState.items.forEach(function (item) {
      if (item.key === key) {
        if (qty <= 0) {
          /* remove: subtract from totals */
          cartState.item_count -= item.quantity;
          cartState.total_price -= item.price * item.quantity;
        } else {
          var diff = qty - item.quantity;
          item.quantity = qty;
          cartState.item_count += diff;
          cartState.total_price += item.price * diff;
          newItems.push(item);
        }
      } else {
        newItems.push(item);
      }
    });
    cartState.items = newItems;
    renderCart(cartState); /* instant render, no wait */

    /* sync with server silently */
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty < 0 ? 0 : qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); }) /* reconcile with server truth */
      .catch(function () { fetchAndRenderCart(); }); /* recover on error */
  }

  /* nav cart icon */
  document.querySelectorAll('.nav-cart').forEach(function (icon) {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });

  /* ============================================================
     CART TOAST — instant, no fetch needed
  ============================================================ */
  function showToast(title, sub) {
    var old = document.querySelector('.cart-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'cart-toast';
    t.innerHTML =
      '<span class="cart-toast-icon">✓</span>' +
      '<div><div class="cart-toast-title">' + title + '</div>' +
      '<div class="cart-toast-sub">' + sub + '</div></div>';
    t.addEventListener('click', function () { openCart(); t.classList.remove('show'); });
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { t.classList.add('show'); });
    });
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { if (t.parentNode) t.remove(); }, 300);
    }, 3500);
  }

  /* ============================================================
     ADD TO CART — fires onSuccess immediately after /cart/add.js,
     then refreshes cart state in background (no waiting for 2nd fetch)
  ============================================================ */
  function doAddToCart(variantId, qty, onSuccess, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        onSuccess(); /* fire immediately — no waiting for cart.js */
        /* refresh cart state in background to keep drawer accurate */
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { renderCart(cart); })
          .catch(function () {});
      })
      .catch(function () { onError && onError(); });
  }

  /* ============================================================
     NAV SCROLL — rAF throttled
  ============================================================ */
  var nav = document.getElementById('mainNav');
  if (nav) {
    var navTicking = false;
    window.addEventListener('scroll', function () {
      if (!navTicking) {
        requestAnimationFrame(function () {
          nav.classList.toggle('scrolled', window.scrollY > 20);
          navTicking = false;
        });
        navTicking = true;
      }
    }, { passive: true });
  }

  /* ============================================================
     REVIEWS
  ============================================================ */
  var reviews = [
    { name: 'Sunita R.',  color: '#00C87A', i: 'SR', s: 5, t: 'Kitchen tiles mein jo daag mahino se the, yeh eraser ne 2 minute mein saaf kar diye. Bilkul no chemicals. Genuinely shocked.' },
    { name: 'Mohit K.',   color: '#0A84FF', i: 'MK', s: 5, t: 'Bhai sach mein magic hai yeh cheez. Switch boards, bathroom tiles, shoes — ek hi pack mein itna kaam ho gaya. Must buy.' },
    { name: 'Deepa M.',   color: '#FF6B35', i: 'DM', s: 5, t: 'Ordered for crayon marks my son left on the wall. Gone in seconds with zero effort. Already ordered 2 more packs.' },
    { name: 'Rajesh B.',  color: '#9B59B6', i: 'RB', s: 5, t: 'Bathroom ki tiles jo saalon se gandi thi, is eraser se 2 minute mein chamak gayi. Bina kisi chemical ke. Bahut accha product hai.' },
    { name: 'Anjali T.',  color: '#E74C3C', i: 'AT', s: 4, t: 'Works really well on walls and tiles. Took a bit more effort on very old stains but still got the job done. Happy overall.' },
    { name: 'Vikas S.',   color: '#F39C12', i: 'VS', s: 5, t: 'Shoes clean karne ke liye use kiya — white sole jo grey ho gayi thi bilkul naye jaisi ho gayi. Hairan ho gaya result dekh ke.' },
    { name: 'Nandita P.', color: '#1ABC9C', i: 'NP', s: 5, t: 'No chemicals, no smell, just water. As a mother I was worried about safety. This is completely safe and works better than anything else.' },
    { name: 'Pradeep G.', color: '#2980B9', i: 'PG', s: 5, t: 'Office ki chairs aur tables par coffee ke purane daag the. Is eraser ne sab saaf kar diya. Bahut badhiya, value for money hai.' },
    { name: 'Kavitha L.', color: '#E91E8C', i: 'KL', s: 5, t: 'Pack of 4 mein itna value milta hai. Ek eraser se pura bathroom clean kar liya. Abhi bhi 3 bache hain. Definitely reorder karungi.' },
    { name: 'Aruna C.',   color: '#27AE60', i: 'AC', s: 4, t: 'Good product, works as described. Kitchen backsplash stains are gone. Delivery was fast. 4 stars because one eraser wore out a bit quickly.' },
    { name: 'Tarun J.',   color: '#8E44AD', i: 'TJ', s: 5, t: 'Car ke andar use kiya — dashboard, seat marks, sab kuch ekdum saaf. Showroom jaisa clean. Ye product sabke ghar mein hona chahiye.' },
    { name: 'Shobha N.',  color: '#D35400', i: 'SN', s: 5, t: 'Mere ghar ki deewaron par bachon ne bahut kuch likha tha. Sab saaf ho gaya — sirf paani se. Bahut khush hoon is product se.' },
    { name: 'Farhan Q.',  color: '#16A085', i: 'FQ', s: 5, t: "Gifted this to my sister for her new home. She called the same day saying it's the most useful gift anyone has given her." },
    { name: 'Lakshmi V.', color: '#C0392B', i: 'LV', s: 5, t: 'COD option tha isliye confident hokar order kiya. 3 din mein delivery aayi. Daag gayab ho gaye. Bahut satisfied hoon.' },
    { name: 'Ramesh H.',  color: '#2C3E50', i: 'RH', s: 5, t: 'Switch boards in my house were black with fingerprints. One wipe with this eraser and they look brand new. Showing this to everyone.' },
  ];

  document.querySelectorAll('.reviews-track').forEach(function (track) {
    var frag = document.createDocumentFragment();
    reviews.forEach(function (r) {
      var stars = '★'.repeat(r.s) + (r.s < 5 ? '☆' : '');
      var card = document.createElement('div');
      card.className = 'review-card';
      card.innerHTML =
        '<div class="review-header">' +
          '<div class="review-avatar" style="background:' + r.color + '">' + r.i + '</div>' +
          '<div><div class="review-name">' + r.name + '</div>' +
          '<div class="review-verified">✓ Verified Buyer</div></div>' +
        '</div>' +
        '<div class="review-stars">' + stars + '</div>' +
        '<p class="review-text">"' + r.t + '"</p>';
      frag.appendChild(card);
    });
    track.appendChild(frag);
  });

  /* ============================================================
     FAQ — height cached, no reflow
  ============================================================ */
  var faqItems = document.querySelectorAll('.faq-item');
  var faqHeights = new Map();
  faqItems.forEach(function (item) {
    var inner = item.querySelector('.faq-a-inner');
    if (inner) faqHeights.set(item, inner.offsetHeight + 18);
  });
  faqItems.forEach(function (item) {
    var ans = item.querySelector('.faq-a');
    if (ans) ans.style.height = '0px';
  });
  faqItems.forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    var ans = item.querySelector('.faq-a');
    if (!btn || !ans) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      faqItems.forEach(function (fi) {
        if (fi === item) return;
        fi.classList.remove('open');
        var fa = fi.querySelector('.faq-a');
        if (fa) fa.style.height = '0px';
      });
      if (isOpen) {
        item.classList.remove('open');
        ans.style.height = '0px';
      } else {
        item.classList.add('open');
        ans.style.height = (faqHeights.get(item) || 80) + 'px';
      }
    });
  });

  /* ============================================================
     BEFORE / AFTER SLIDER — rAF throttled
  ============================================================ */
  var baCon    = document.getElementById('baContainer');
  var baAfter  = document.getElementById('baAfter');
  var baHandle = document.getElementById('baHandleWrap');
  if (baCon && baAfter && baHandle) {
    var sliderDragging = false;
    var sliderTicking  = false;
    var pendingX       = null;

    function applySlider(p) {
      p = Math.min(Math.max(p, 2), 98);
      baAfter.style.clipPath   = 'inset(0 ' + (100 - p) + '% 0 0)';
      baHandle.style.left      = p + '%';
      baHandle.style.transform = 'translateX(-50%)';
    }
    function scheduleSlider(clientX) {
      pendingX = clientX;
      if (!sliderTicking) {
        requestAnimationFrame(function () {
          if (pendingX !== null) {
            var rect = baCon.getBoundingClientRect();
            applySlider(((pendingX - rect.left) / rect.width) * 100);
            pendingX = null;
          }
          sliderTicking = false;
        });
        sliderTicking = true;
      }
    }
    applySlider(50);
    baCon.addEventListener('mousedown', function (e) { sliderDragging = true; scheduleSlider(e.clientX); e.preventDefault(); });
    document.addEventListener('mousemove', function (e) { if (sliderDragging) scheduleSlider(e.clientX); });
    document.addEventListener('mouseup', function () { sliderDragging = false; });
    baCon.addEventListener('touchstart', function (e) { sliderDragging = true; scheduleSlider(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('touchmove', function (e) { if (sliderDragging) scheduleSlider(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('touchend', function () { sliderDragging = false; });
    setTimeout(function () {
      var p = 50, dir = -1;
      var t = setInterval(function () { p += dir * 1.2; applySlider(p); if (p <= 28) dir = 1; if (p >= 50 && dir === 1) clearInterval(t); }, 16);
    }, 900);
  }

  /* ============================================================
     SCROLL REVEAL
  ============================================================ */
  var revIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('visible'); revIO.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { revIO.observe(el); });

  /* ============================================================
     STICKY BAR — rAF throttled
  ============================================================ */
  var stickyBar = document.getElementById('stickyBar');
  if (stickyBar) {
    var stickyTicking = false;
    window.addEventListener('scroll', function () {
      if (!stickyTicking) {
        requestAnimationFrame(function () {
          stickyBar.style.display = window.scrollY > 480 ? 'flex' : 'none';
          stickyTicking = false;
        });
        stickyTicking = true;
      }
    }, { passive: true });
  }

  /* ============================================================
     PRODUCT PAGE — Gallery
  ============================================================ */
  var mainImg = document.getElementById('pdpMainImg');
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.style.opacity = '0.4';
        mainImg.src = thumb.dataset.src;
        mainImg.onload = function () { mainImg.style.opacity = '1'; };
      }
    });
  });

  /* ============================================================
     PRODUCT PAGE — Qty
  ============================================================ */
  var qtyInput = document.getElementById('pdpQty');
  if (qtyInput) {
    var qtyMinus = document.getElementById('pdpMinus');
    var qtyPlus  = document.getElementById('pdpPlus');
    if (qtyMinus) qtyMinus.addEventListener('click', function () { var v = parseInt(qtyInput.value) || 1; if (v > 1) qtyInput.value = v - 1; });
    if (qtyPlus)  qtyPlus.addEventListener ('click', function () { var v = parseInt(qtyInput.value) || 1; if (v < 10) qtyInput.value = v + 1; });
  }

  /* ============================================================
     PRODUCT PAGE — Variant select
  ============================================================ */
  var varSel  = document.getElementById('pdpVariantSelect');
  var priceEl = document.getElementById('pdpPrice');
  var oldEl   = document.getElementById('pdpPriceOld');
  if (varSel) {
    varSel.addEventListener('change', function () {
      var opt = varSel.options[varSel.selectedIndex];
      if (priceEl && opt.dataset.price)   priceEl.textContent = opt.dataset.price;
      if (oldEl   && opt.dataset.compare) oldEl.textContent   = opt.dataset.compare;
    });
  }

  /* ============================================================
     PRODUCT PAGE — Add to Cart (instant tap feedback)
  ============================================================ */
  var pdpForm   = document.getElementById('pdpForm');
  var pdpAtcBtn = document.getElementById('pdpAtcBtn');

  if (pdpForm && pdpAtcBtn) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (pdpAtcBtn.disabled) return;

      var vi = pdpForm.querySelector('[name="id"]');
      var qi = pdpForm.querySelector('[name="quantity"]');
      if (!vi) return;

      var origHTML = pdpAtcBtn.innerHTML;
      var qty = parseInt(qi ? qi.value : 1) || 1;

      /* ── instant feedback on tap ── */
      pdpAtcBtn.disabled = true;
      pdpAtcBtn.innerHTML = '<span>✓ Added!</span>';
      pdpAtcBtn.classList.add('success');

      /* optimistic count bump */
      var currentCount = parseInt((document.querySelector('.nav-cart-count') || {}).textContent || '0');
      updateCartCount(currentCount + qty);
      showToast('Added to cart!', 'Tap to view your cart →');

      doAddToCart(vi.value, qty,
        function () {
          /* already showing success — just reset after delay */
          setTimeout(function () {
            pdpAtcBtn.innerHTML = origHTML;
            pdpAtcBtn.classList.remove('success');
            pdpAtcBtn.disabled = false;
          }, 1800);
        },
        function () {
          /* rollback on error */
          updateCartCount(currentCount);
          pdpAtcBtn.innerHTML = origHTML;
          pdpAtcBtn.classList.remove('success');
          pdpAtcBtn.disabled = false;
        }
      );
    });
  }

  /* ============================================================
     PRODUCT PAGE — Buy Now (instant redirect)
  ============================================================ */
  var pdpBuyNow = document.getElementById('pdpBuyNow');
  if (pdpBuyNow && pdpForm) {
    pdpBuyNow.addEventListener('click', function (e) {
      e.preventDefault();
      var vi = pdpForm.querySelector('[name="id"]');
      var qi = pdpForm.querySelector('[name="quantity"]');
      pdpBuyNow.textContent = 'Going to checkout...';
      pdpBuyNow.style.opacity = '0.85';
      doAddToCart(
        vi ? vi.value : '',
        parseInt(qi ? qi.value : 1) || 1,
        function () { window.location.href = '/checkout'; },
        function () { window.location.href = '/checkout'; }
      );
    });
  }

  /* ============================================================
     PRODUCT PAGE — Sticky ATC (instant tap feedback)
  ============================================================ */
  var stickyAtcBtn = document.getElementById('stickyAtcBtn');
  if (stickyAtcBtn && pdpForm) {
    stickyAtcBtn.addEventListener('click', function () {
      var vi = pdpForm.querySelector('[name="id"]');
      var qi = pdpForm.querySelector('[name="quantity"]');
      if (!vi) { openCart(); return; }

      var orig = stickyAtcBtn.textContent;
      var qty = parseInt(qi ? qi.value : 1) || 1;

      /* ── instant feedback on tap ── */
      stickyAtcBtn.textContent = '✓ Added!';
      stickyAtcBtn.style.background = '#00cc70';
      var currentCount = parseInt((document.querySelector('.nav-cart-count') || {}).textContent || '0');
      updateCartCount(currentCount + qty);
      showToast('Added to cart!', 'Tap to view your cart →');

      doAddToCart(vi.value, qty,
        function () {
          setTimeout(function () {
            stickyAtcBtn.textContent = orig;
            stickyAtcBtn.style.background = '';
          }, 1800);
        },
        function () {
          updateCartCount(currentCount);
          stickyAtcBtn.textContent = orig;
          stickyAtcBtn.style.background = '';
        }
      );
    });
  }

  /* ============================================================
     PRODUCT PAGE — Final CTA scroll
  ============================================================ */
  var ctaScrollBtn = document.getElementById('ctaScrollBtn');
  if (ctaScrollBtn) {
    ctaScrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function () {
        if (pdpAtcBtn && !pdpAtcBtn.disabled) pdpAtcBtn.click();
      }, 600);
    });
  }

});
